<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2019-12-18 16:50:14
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-15 09:58:30
-->
<template>
  <div class="content">
    <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header>
    <!-- <div class="cont">
       <img src="../../assets/img/role.png" alt="">
    </div> -->
    <div  v-html="content" class='cont'></div>
  </div>
</template>

<script>
import { getActivityRuleContent } from "@/api/picker/index.js";
export default {
  data() {
    return {
        isWX:'1',
        headerMsg: {
          url: "",
        },
        content: "",
    };
  },
  mounted() {
    //   this.rule()
     this.isWX = this.GetQueryString("wx");
     this.getContent()
  },
  
  methods: {
    getContent() {
      getActivityRuleContent({
        type: "5", //关注9和10， type 教程类型。2.选菜师教程，3.城市合伙人教程，4.无码商品教程，5：选菜师协议，6：城市合伙人协议，7.选菜师攻略教程，
        //8社区店长攻略，9爆款活动规则,10拼单活动规则，11：打印说明文档,12 店长协议,13悦买用户协议，14悦卖用户协议
      }).then((res) => {
        // console.log(res);
        let result = res.content.content
          .replace(/&#x3c;/g, "<")
          .replace(/&#x3e;/g, ">")
          .replace(/&#x22;/g, '"');
        // let result2 = result1.replace(/&#x3e;/g,'>')

        this.content = result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: auto;
  overflow: auto;
  width: auto;
  padding: 0 10px;
  img {
    width: 371px;
  }
  .cont {
    height: fit-content;
    margin-top: 10px;
    text-align: left;
  }
  .mt {
    height: fit-content;
    margin-top: 0;
  }
}
</style>
